module.exports = __webpack_public_path__ + "36134a68f5eae87055371a9a8678a2b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/View_Results_Icon.png
// module id = XI/t
// module chunks = 22